var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M21.6002 15.1992H15.2002V21.4992L21.6002 15.1992Z",
    fill: "#7FBB51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.89941H15.2",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5996H15.2",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.1992H11.6",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9002 21.4996H2.6002C2.1002 21.4996 1.7002 21.0996 1.7002 20.5996V2.4996C1.7002 1.9996 2.1002 1.59961 2.6002 1.59961H20.7002C21.2002 1.59961 21.6002 1.9996 21.6002 2.4996V14.7996C21.6002 14.9996 21.5002 15.2996 21.3002 15.3996L15.5002 21.1996C15.3002 21.3996 15.1002 21.4996 14.9002 21.4996Z",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5002 15.1992H15.2002V21.3992",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.d5ca7667367aece868bcb9f035a21c21.svg";
export { ForwardRef as ReactComponent };